import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  QueryColumn,
  QueryColumnSortOrder,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';

import { GUID } from '@barthauer/abc/core';
import {
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  _AbcContextMenuComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
} from '@barthauer/abc/ui-components';
import { Address } from '@barthauer/custom/arena';
import { DefaultIcons, Person, Project, SubProject } from '@barthauer/custom/xmt-models';
import { DxDataGridModule, DxFormModule, DxRadioGroupModule } from 'devextreme-angular';
import { CellPreparedEvent, Column } from 'devextreme/ui/data_grid';
/* import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf'; */
import { Department } from '@barthauer/custom/xmt-models';
import { loadMessages } from 'devextreme/localization';
import { forkJoin, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import {
  ActionType,
  NotificationMessage,
  PermissionContext,
  ROLES,
  ToastType,
} from '../../../models/enumeration-list.model';
import { AppService } from '../../../services/app.service';
import { DataService, ObjectKeys } from '../../../services/data.service';
import { NotificationService } from '../../../services/notification.service';
import { FavoritesService } from '../../../shared/favorite/favorites.service';
import { SharedModule } from '../../../shared/shared.module';
import {
  ProjectState,
  ProjectStateDe,
  ProjectStateIcons,
  SubProjectViewModel,
} from '../../../view-models/sub-project.view-model';
import { SubProjectService } from './../sub-project.service';

import { CheckPermissionDirective } from '../../../directives/check-permession-directive';
import { BasedRoleOPathService } from '../../../services/based-role-opath.service';
import { Persons, StuffMemberPerson } from '../../measure/measure.model';
import { ScreenService } from '../../../services/screen.service';
import { ObjectTypeService } from '../../../services/object-type.service';

@Component({
  selector: 'ubt-geods-sub-project-list',
  templateUrl: './sub-project-list.component.html',
  styleUrls: ['./sub-project-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
    DxRadioGroupModule,
    CommonModule,
    DxFormModule,
    _AbcFormComponent,
    DxDataGridModule,
    AbcPopupComponent,
    AbcSpeedDialActionComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective,
  ],
  providers: [SubProjectService],
})
export class SubProjectListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('createSubProjectPopup') createSubProjectPopup: AbcPopupComponent;
  @ViewChild('event') eventSelectBox: _AbcSelectBoxComponent;
  @ViewChild('responsible') responsibleSelectBox: _AbcSelectBoxComponent;
  @ViewChild('support') supportSelectBox: _AbcSelectBoxComponent;
  @ViewChild('form') form: _AbcFormComponent;
  @ViewChild('confirmSubProjectPopup') confirmSubProjectPopup: AbcPopupComponent;
  @ViewChild('subProjectGrid') subProjectGrid: _AbcGridComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;

  public subProject: SubProject = new SubProject(null);
  public project: Project = new Project(null);
  public subProjectDesignation: string;
  public pluralTitle: string;
  public subProjectsViewModel: SubProjectViewModel[] = [];
  public subProjects: SubProject[] = [];
  public projects: Project[] = [];
  public ROLES = ROLES;
  public RespensiblePersonDataSource: StuffMemberPerson[] = [];
  public ResponsibleSupportPersonDataSource: StuffMemberPerson[] = [];
  private subscriptions: Subscription[] = [];
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-SubProject-View-report'),
      onClick: (e) => {
        this.routeToReport(this.subProject.Id);
      },
    },
    {
      text: this.dataService.res('Ubt-SubProject-Edit-Subproject'),
      onClick: (event) => {
        this.openEditSubProject(event);
      },
    },
    {
      text: this.dataService.res('Ubt-SubProject-Delete-Subproject'),

      onClick: () => {
        this.openConfirmTaskDialog();
      },
    },
    {
      text:
        this.subProject['IsFavorite'] === 1
          ? this.dataService.res('Ubt-SubProject-Remove-from-favorites')
          : this.dataService.res('Ubt-SubProject-Add-to-favorites'),

      onClick: (e) => {
        this.updateFavorite();
      },
    },
  ];
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res('Ubt-CreateSubproject-Implementation-Status'),
      dataField: 'implementationStatus',
      minWidth: 50,
      width: 50,
      alignment: 'center',
      visibleIndex: 0,
      hidingPriority: 5,
    },
    {
      caption: this.dataService.res('Ubt-CreateMeasure-Title'),
      dataField: 'label',
      visibleIndex: 1,
      hidingPriority: 6,
    },
    {
      caption: this.dataService.res('Ubt-MeasureDetail-Responsible'),
      dataField: 'responsible',
      visibleIndex: 2,
      hidingPriority: 4,
      lookup: { valueExpr: 'Id', displayExpr: this.dataService.getResponsibleFullName, dataSource: [] },
    },

    {
      caption: this.dataService.res('Ubt-SubProject-Create-HighLights'),
      dataField: 'highlights',
      visibleIndex: 3,
      hidingPriority: 3,
    },
    {
      caption: this.dataService.res('Ubt-SubProject-Create-Lowlights'),
      dataField: 'lowlights',
      visibleIndex: 4,
      hidingPriority: 2,
    },
    {
      type: 'buttons',
      caption: '',
      alignment: 'left',
      minWidth: 50,
      width: '50px',
      dataField: '',
      visibleIndex: 5,
    },
  ];
  public responsibles: Person[] = [];
  private subProjectId: string;
  public disableDepartment = true;
  public isFavorite = true;
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  public Action = ActionType;
  public PermissionContext = PermissionContext;
  public readonly subProjectStates = [
    {
      text: this.dataService.res('Ubt-SubProject-Create-State-Risk'),
      value: ProjectState.NORISK,
    },
    {
      text: this.dataService.res('Ubt-SubProject-Create-State-Behind-Schedule'),
      value: ProjectState.BEHINDSCHEDUEL,
    },
    {
      text: this.dataService.res('Ubt-SubProject-Create-State-Countless'),
      value: ProjectState.COUNTMEASURES,
    },
    {
      text: this.dataService.res('Ubt-SubProject-Create-State-Critical'),
      value: ProjectState.CRITICAL,
    },
  ];
  public isUpdating = false;
  public submitButtonText = 'Create';

  public cancelButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Cancel'),
    onClick: () => this.clearWindow(),
  };
  public personColumns: QueryColumn[] = [];
  public subProjectColumns: QueryColumn[] = [];
  constructor(
    private persistenceService: PersistenceService,
    public dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public subProjectService: SubProjectService,
    private coreDataService: CoreDataService,
    public appService: AppService,
    private datePipe: DatePipe,
    public favoritesService: FavoritesService,
    private notificationService: NotificationService,
    private opathService: BasedRoleOPathService,
    private readonly screenService: ScreenService,
    private objectTypeService: ObjectTypeService,
  ) {
    //loadMessages(loadMessages);
  }

  ngOnInit(): void {
    this.dataService.floatingButtonConfig();

    this.appService.showLoader(true);
    this.subProject = new SubProject(null);
    this.subProjectColumns.push(
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('ParentId', 'ParentId', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Designation', 'Label', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('IdRefResponsible', 'IdRefResponsible', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn(
        'IdRefResponsibleSupport',
        'IdRefResponsibleSupport',
        QueryColumnSortOrder.None,
      ),
      this.coreDataService.createQueryColumn('Highlights', 'Highlights', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Lowlights', 'Lowlights', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('ImplementationStatus', 'ImplementationStatus', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('StartDate', 'StartDate', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('EndDate', 'EndDate', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('IdRefDepartment', 'Department', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('IdRefAddress', 'Company', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Count(measures)', 'measuresCount', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn(
        "Exists(Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id])",
        'IsFavorite',
      ),
      this.coreDataService.createQueryColumn(
        "Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id].Id",
        'BoxDetailId',
      ),
    );
    const oPath = this.checkSubprojectOpath();
    const addressColumns = [
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Name', 'Name', QueryColumnSortOrder.None),
    ];

    const projectColumns = [
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('StartDate', 'StartDate', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('EndDate', 'EndDate', QueryColumnSortOrder.None),
    ];
    const oPathProject = 'Id=' + "'" + sessionStorage.getItem('projectId') + "'";

    forkJoin([
      this.dataService.prepareStaffMembers(),
      this.dataService.readObjects<SubProject[]>(ObjectKeys.SUBPROJECT, this.subProjectColumns, oPath),
      this.dataService.readObjects<Address[]>(ObjectKeys.ADDRESS, addressColumns),
      this.dataService.readObjects<Project[]>(ObjectKeys.PROJECT, projectColumns, oPathProject),
    ])
      .pipe(first())
      .subscribe(
        (data) => {
          if (Array.isArray(data[3]) && data[3].length > 0) {
            this.project = data[3][0];
          }
          if (Array.isArray(data[0]) && data[0].length > 0) {
            this.getSubprojectResponsibleDataSource(data[0]);
            this.dataService.cachedResponsiblesResponse = data[0].sort((a, b) => a.LastName.localeCompare(b.LastName));
            this.subProjectGrid.instance.columnOption(
              2,
              'lookup.dataSource',
              this.dataService.cachedResponsiblesResponse,
            );
          }
          this.dataService.cachedCompany = data[2].sort((a, b) => a.Name.localeCompare(b.Name));
          if (Array.isArray(data[1]) && data[1].length > 0) {
            this.appService.subProjectIds = [];
            this.appService.subProjects = data[1];
            data[1].forEach((subProject) => {
              this.appService.subProjectIds.push(subProject.Id);
              const subProjectViewModel = new SubProjectViewModel(subProject);
              this.subProjectsViewModel.push(subProjectViewModel);
            });
          } else {
            this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
          }
        },
        (error) => {
          console.error(error);
          this.appService.showLoader(false);
          this.cdr.markForCheck();
        },
        () => {
          this.cdr.markForCheck();
          this.appService.showLoader(false);
        },
      );

    this.subscriptions.push(
      this.dataService.updateGridData$.subscribe((subProject: SubProjectViewModel) => {
        this.subProjectsViewModel.push(subProject);
        this.cdr.markForCheck();
      }),
    );
  }
  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.screenService.screen$.subscribe(({ screenSize, isMenuOpened }) => {
        this.screenService.setGridColumnsWidth(
          this.columnsHeader,
          this.subProjectGrid,
          screenSize,
          isMenuOpened,
          this.getColumnWidth,
        );
      }),
    );
  }
  private getColumnWidth = (key: string, isMenuOpened: boolean, largeScreenAddition: number = 0): string => {
    switch (key) {
      case '':
        return '30px';
      case 'implementationStatus':
        return isMenuOpened
          ? `${(70 + largeScreenAddition).toString()}px`
          : `${(100 + largeScreenAddition).toString()}px`;
      default:
        return isMenuOpened
          ? `${(235 + largeScreenAddition).toString()}px`
          : `${(305 + largeScreenAddition).toString()}px`;
    }
  };
  public getSubprojectResponsibleDataSource(persons: Persons[]): void {
    const staffMember = persons.map(({ FirstName, Id, LastName, AddressPerson }) => ({
      FirstName,
      Id,
      LastName,
      Position: AddressPerson?.[0]?.Position || '',
    }));

    this.ResponsibleSupportPersonDataSource = staffMember.filter((t) =>
      [ROLES.Admin, ROLES.CoreTeam, ROLES.SubprojectDeputy, ROLES.SteeringCommittee].includes(t.Position as ROLES),
    );
    this.RespensiblePersonDataSource = staffMember.filter((t) =>
      [ROLES.Admin, ROLES.CoreTeam, ROLES.SubprojectResponsible, ROLES.SteeringCommittee].includes(t.Position as ROLES),
    );
  }
  public checkSubprojectOpath(): string {
    return this.opathService.checkSubprojectOPath();
  }
  public updateFavorite() {
    if (this.subProject['IsFavorite'] === 1) {
      return this.deleteFavorite();
    } else {
      return this.addFavorite();
    }
  }

  public addFavorite(): void {
    const companyName = sessionStorage.getItem('companyName') || 'Unknown Company';
    const projectName = sessionStorage.getItem('projectName') || 'Unknown Project';
    const concatenatedString = `${this.subProject.Label} / ${companyName} / ${projectName} / `;

    this.favoritesService
      .persistFavoriten(GUID.newGUID(), this.objectTypeService.getObjectTypesValue(ObjectKeys.SUBPROJECT), this.subProject.Id, concatenatedString)
      .subscribe((data) => {
        this.subProjectsUpdateState(this.subProject, 'add', data);
      });
  }

  public deleteFavorite(): void {
    this.favoritesService.deleteFavoriten(this.subProject['BoxDetailId']);
    this.subProjectsUpdateState(this.subProject, 'delete');
  }

  public isFavoriteVisible(e) {
    if (e.row?.data.subProject.IsFavorite === 1) {
      return true;
    } else {
      return false;
    }
  }

  public getRadioStyle(data: any): string {
    switch (data?.value) {
      case ProjectState.NORISK:
        return 'green-circle';
      case ProjectState.COUNTMEASURES:
        return 'orange-circle';
      case ProjectState.BEHINDSCHEDUEL:
        return 'yellow-circle';
      case ProjectState.CRITICAL:
        return 'red-circle';
      default:
        return 'default-circle';
    }
  }
  public isRepportDisabled(e): boolean {
    if (e.row.data.subProject.measuresCount === 0 || e.row.data.subProject.measuresCount === undefined) {
      return true;
    } else {
      return false;
    }
  }

  public onRowPrepared = (e) => {
    if (e.rowType === 'data') {
      this.getFullName(e.data.subProject?.Responsible);
    }
  };

  public onCellPrepared(e: CellPreparedEvent) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }

    if (e.rowType === 'header') {
      e.cellElement.style.textAlign = 'left';
    } else if (e.rowType === 'data' || e.rowType === 'detailAdaptive') {
      switch (e.column.dataField) {
        case '':
          e.cellElement.style.width = '50px !important';
          break;
        case 'label':
        case 'implementationStatus':
          if (e.column.dataField === 'implementationStatus') {
            e.cellElement.style.width = '5%';
            e.cellElement.style.textAlign = 'center';
            var newText = e.cellElement.textContent.replace(/ /g, '_');
            const tooltipContent = this.returntooltipText(newText);

            e.cellElement.textContent = '';
            e.cellElement.setAttribute('title', tooltipContent);
            const statusDiv = document.createElement('div');
            const statusSpan = document.createElement('span');
            const statutIcon = document.createElement('div');
            statutIcon.setAttribute('class', 'filled-character');
            statusDiv.style.display = 'flex';
            statusDiv.style.placeContent = 'center';
            statusSpan.style.flex = '1';
            statusSpan.style.overflow = 'hidden';
            statusSpan.style.whiteSpace = 'nowrap';
            statusSpan.style.textOverflow = 'ellipsis';
            statusSpan.style.display = 'inline-block';

            switch (e.data?.implementationStatus) {
              case 'Critical':
                statutIcon.style.background = 'red';
                break;
              case 'Behind schedule':
                statutIcon.style.background = 'yellow';
                break;
              case 'Counter measures necessary':
                statutIcon.style.background = 'orange';
                break;
              case 'Countermeasures necessary':
                statutIcon.style.background = 'orange';
                break;
              case 'No Risk':
                statutIcon.style.background = '#3faf6c';
                break;
            }

            statusDiv.append(statutIcon);
            e.cellElement.append(statusDiv);
          }
      }
    }
  }

  public onCellClick(e) {
    if (e.column?.command === 'adaptive') {
      e.event?.stopPropagation();
      return;
    }
    this.subProject = e.data.subProject;
    if (e.rowType === 'data') {
      if (e.column.type === 'buttons') {
        e.cellElement.className = 'context-menu-icon' + e.rowIndex;
        e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;

        this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
        this.contextMenuItems[1].visible = this.dataService.hasPermission(
          PermissionContext.Subproject,
          ActionType.UPDATE,
        );

        this.contextMenuItems[2].visible = this.dataService.hasPermission(
          PermissionContext.Subproject,
          ActionType.DELETE,
        );

        this.contextMenuItems[3].text =
          this.subProject['IsFavorite'] === 1
            ? this.dataService.res('Ubt-SubProject-Remove-from-favorites')
            : this.dataService.res('Ubt-SubProject-Add-to-favorites');

        this.contextMenu.instance.show();
      } else this.routeToReport(e.data.subProject.Id);
    }
  }

  public subProjectsUpdateState(e, state: string, favoriteData?): void {
    let selectedIndex = this.subProjectsViewModel.findIndex((subProject) => {
      return subProject.id === e.Id;
    });
    if (state === 'add') {
      const clonedItem = { ...e, IsFavorite: 1, BoxDetailId: favoriteData.Id };
      this.subProjectsViewModel[selectedIndex];
      this.subProjectsViewModel[selectedIndex] = new SubProjectViewModel(clonedItem);
      this.notificationService.callNotification({
        message: NotificationMessage.AddToFavorite,
        type: ToastType.SUCCESS,
      });

      this.cdr.markForCheck();
    } else {
      const clonedItem = { ...e, IsFavorite: 0 };
      this.subProjectsViewModel[selectedIndex] = new SubProjectViewModel(clonedItem);
      this.notificationService.callNotification({
        message: NotificationMessage.RemovedFromFavorite,
        type: ToastType.SUCCESS,
      });
      this.cdr.markForCheck();
    }
  }

  public prepareDepartments(id: string): void {
    const departmentColumns = [
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
      this.coreDataService.createQueryColumn('Designation', 'Designation', QueryColumnSortOrder.None),
    ];
    const departmentOpath = 'ParentId=' + "'" + id + "'";
    this.dataService.readObjects<Department[]>(ObjectKeys.DEPARTMENT, departmentColumns, departmentOpath).subscribe(
      (departments) => {
        this.dataService.cachedDepartement = departments;
        this.cdr.markForCheck();
      },
      (error) => {
        console.error(error);
      },
      () => {
        this.disableDepartment = false;
      },
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  public onExporting(e): void {
    /*     const myDate = this.datePipe.transform(new Date(), '/yyyy-MM-dd');
    if (e.format == 'pdf') {
      const doc = new jsPDF();
      exportDataGridPDF({
        jsPDFDocument: doc,
        component: e.component,
        indent: 5,
      }).then(() => {
        doc.save('subProject/' + myDate + '.pdf');
      });
    } else {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
      exportDataGridExcel({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'subProject/' + myDate + '.xlsx');
        });
      });
      e.cancel = true;
    } */
  }

  public openEditSubProject = (e) => {
    this.isUpdating = true;
    this.cdr.detectChanges();
    this.disableDepartment = false;
    this.submitButtonText = 'Update';
    this.createSubProjectPopup.title = this.dataService.res('Ubt-SubProject-Update-SubProject');
    this.createSubProjectPopup.instance.show();
  };

  public openConfirmTaskDialog = () => {
    this.subProjectDesignation = this.subProject.Label;
    this.subProjectId = this.subProject.Id;
    loadMessages({
      de: {
        'Ubt-message-delete': 'Sind Sie sicher, dass Sie das "' + this.subProjectDesignation + '" löschen wollen?',
      },
      en: {
        'Ubt-message-delete': 'Are you sure you want to delete "' + this.subProjectDesignation + '" this record?',
      },
    });
    this.confirmSubProjectPopup.instance.show();
  };

  public removeRow = (event): void => {
    this.subscriptions.push(
      this.dataService.deleteObject(ObjectKeys.SUBPROJECT, this.subProjectId).subscribe(
        () => {
          const index = this.subProjectsViewModel.findIndex((item) => item.id === this.subProjectId);
          this.subProjectsViewModel.splice(index, 1);
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });
          this.cdr.markForCheck();
          this.confirmSubProjectPopup.instance.hide();
        },
        (error) => {
          console.error(error);
          this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
        },
      ),
    );
  };

  public rowUpdated(event): void {
    if (this.subProject?.Label !== '') {
      event.preventDefault();
      this.persistSubProject(PersistMode.Update);
    } else {
      this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
      event.cancel = true;
    }
  }

  public getFullName(id: string) {
    const responsible = this.dataService.cachedResponsiblesResponse.find((x) => x.Id === id);
    if (responsible) return responsible.FirstName + ', ' + responsible.LastName;
  }

  public openSubProjectDialog(): void {
    this.isUpdating = false;
    this.subProject = new SubProject(null);
    this.subProject.ImplementationStatus = ProjectState.COUNTMEASURES;
    this.submitButtonText = 'Create';
    this.createSubProjectPopup.title = this.dataService.res('Ubt-SubProject-Create-SubProject');
    this.createSubProjectPopup.instance.show();
  }

  public abortTaskDelete() {
    this.confirmSubProjectPopup.instance.hide();
  }

  public async createSubProject(event): Promise<void> {
    event.preventDefault();
    const isDuplicate = await this.checkDuplicateSubProject();

    if (isDuplicate) {
      this.notificationService.callNotification({
        message: this.dataService.res('Ubt-SubPoject-Create-Duplicate-Error'),
        type: ToastType.ERROR,
      });
      return;
    }
    if (this.isUpdating === false) {
      this.persistSubProject(PersistMode.Insert);
    } else {
      this.rowUpdated(event);
    }
  }
  private checkDuplicateSubProject(): Promise<boolean> {
    const projectId = sessionStorage.getItem('projectId');
    const label = this.subProject.Label?.trim();

    if (!label || !projectId) return Promise.resolve(false);

    const duplicateColumns: QueryColumn[] = [
      this.coreDataService.createQueryColumn(
        `iif(Exists(Type(xmtSubProject)[ParentId='${projectId}' AND Designation='${label}'${this.isUpdating ? ` AND NOT Id='${this.subProject.Id}'` : ''}]), true, false)`,
        'IsDuplicate',
      ),
    ];

    const oPath = `Id='${projectId}'`;

    return new Promise((resolve) => {
      this.dataService
        .readObjects<any[]>(ObjectKeys.PROJECT, duplicateColumns, oPath)
        .pipe(first())
        .subscribe({
          next: (results) => resolve(results?.[0]?.IsDuplicate === 1),
          error: () => resolve(false),
        });
    });
  }
  private persistSubProject(mode: PersistMode) {
    const subProjectPersistQuery: TargetObjectData = new TargetObjectData();
    subProjectPersistQuery.ObjectKey = new ObjectKey();
    subProjectPersistQuery.ObjectKey.ObjectType = ObjectKeys.SUBPROJECT;
    const currentCompanyId = sessionStorage.getItem('profileAddressId');
    const subProjectColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: sessionStorage.getItem('projectId') },
      { Name: 'Designation', Value: this.subProject.Label },
      { Name: 'IdRefResponsible', Value: this.subProject.IdRefResponsible ? this.subProject.IdRefResponsible : null },
      {
        Name: 'IdRefResponsibleSupport',
        Value: this.subProject.IdRefResponsibleSupport ? this.subProject.IdRefResponsibleSupport : null,
      },
      { Name: 'Highlights', Value: this.subProject.Highlights },
      { Name: 'Lowlights', Value: this.subProject.Lowlights },
      { Name: 'StartDate', Value: new Date(this.subProject.StartDate) },
      { Name: 'EndDate', Value: new Date(this.subProject.EndDate) },
      { Name: 'IdRefAddress', Value: currentCompanyId },
      { Name: 'IdRefDepartment', Value: this.subProject.Department?.toString() },
      { Name: 'ImplementationStatus', Value: this.subProject.ImplementationStatus },
    ];
    subProjectPersistQuery.Mode = mode;
    if (mode == PersistMode.Update) subProjectPersistQuery.ObjectKey.Id = this.subProject.Id;
    subProjectPersistQuery.TargetColumns = subProjectColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = subProjectPersistQuery;
    this.subscriptions.push(
      this.persistenceService.executePersistObjectQuery(persistObject).subscribe(
        (data: any) => {
          const subProjectViewMOdel = new SubProjectViewModel(this.subProject);
          if (mode == PersistMode.Insert) {
            this.subProject.Id = data.Id;
            this.disableDepartment = true;
            this.dataService.updateGridData(subProjectViewMOdel);
            this.isFavorite = false;
            this.cdr.markForCheck();
          }
          this.clearWindow();
        },
        (error) => {
          if (!sessionStorage.getItem('projectId')) {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
          } else {
            this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
          }
        },
        () => {
          this.subProject = new SubProject(null);
          this.cdr.markForCheck();
        },
      ),
    );
  }
  public clearWindow(): void {
    this.createSubProjectPopup.instance.hide();
  }

  public onGridCellPrepared(event): string {
    if (event.column?.dataField === 'implementationStatus') {
      event.cellElement.style.textAlign = 'center';
      const value: string = event?.value;
      if (event.rowType === 'data') {
        if (value === ProjectState.NORISK) {
          return (event.cellElement.innerHTML = ProjectStateIcons.GREEN);
        } else if (value === ProjectState.BEHINDSCHEDUEL) {
          return (event.cellElement.innerHTML = ProjectStateIcons.YELLOW);
        } else if (value === ProjectState.CRITICAL) {
          return (event.cellElement.innerHTML = ProjectStateIcons.RED);
        } else if (value === ProjectState.COUNTMEASURES) {
          return (event.cellElement.innerHTML = ProjectStateIcons.GRAY);
        } else {
          return (event.cellElement.innerHTML = ProjectStateIcons.GRAY);
        }
      }
    }
  }
  routeToReport(id: string) {
    this.router.navigate(['subProjectDetail', id]);
  }
  public returntooltipText(newText: string): string {
    for (let state in ProjectStateDe) {
      if (state === newText) {
        return this.dataService.res(ProjectStateDe[state]);
      }
    }
    return ' ';
  }
}
